import { Component, OnInit, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DateUtilService, CommonModalService } from 'gung-common';
import { SavedCartTableComponent, AuthService, CartsService, ProductService, CartService, GungModalService, PriceService, CartExportService, Cart, gungAddRemoveSpinner, AssortmentService, ProductInputQuantityConfigService, Product } from 'gung-standard';
import { CAR_LINER_FREE_TEXT_PRODUCT_ID } from '../car-liner-saved-quote-table/car-liner-saved-quote-table.component';

@Component({
  selector: 'car-liner-saved-cart-table',
  templateUrl: './car-liner-saved-cart-table.component.html',
  styleUrls: ['./car-liner-saved-cart-table.component.scss'],
  standalone: false
})
export class CarLinerSavedCartTableComponent extends SavedCartTableComponent implements OnInit {

  protected commonModalService = inject(CommonModalService)

  freeTextProductId = CAR_LINER_FREE_TEXT_PRODUCT_ID;

  mapData: {
    [id: string]: {
      qty: number;
      product: Product;
      productId: string;
      productPartialId?: string;
      extra?: any;
    }[];
  } = {};

  ngOnInit(): void {
  }

  protected setMappedData(cartId: string, data: { qty: number; product: Product; productId: string }[], forceUpdate?: boolean): void {
    if (!this.mapData[cartId] || forceUpdate) {
      const cart = this.data?.find(c => c.id === cartId);
      this.mapData[cartId] = data
        .map((row, i) => {
          const cartRow = cart?.data?.rows?.[i];
          return {
            qty: row.qty,
            product: row.product,
            productId: row.productId,
            productPartialId: cartRow?.productPartialId,
            extra: cartRow?.extra
          };
        })
        .filter(row => !!row.product);
    }
  }

  addUserToCart(cart: Cart, { target }) {
    gungAddRemoveSpinner(target);
    const username = '';
    this.commonModalService.openListManagementModal('ENTER_USERNAME', 'USERNAME', cart.extra.allowedUsername).then(
      newList => {
        if (newList) {
          // if (cart.extra.allowedUsername && Array.isArray(cart.extra.allowedUsername)) {
          //   cart.extra.allowedUsername.push(value);
          // } else {
          //   cart.extra.allowedUsername = [ value ];
          // }
          cart.extra.allowedUsername = newList;
          this.cartsService.updateSavedCart(cart).subscribe({
            next: v => gungAddRemoveSpinner(target),
            error: e => gungAddRemoveSpinner(target)
          });
        } else {
          gungAddRemoveSpinner(target);
        }
      },
      _ => {
        gungAddRemoveSpinner(target);
      }
    );
  }
}
